"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    menuItemClassNames: function() {
        return menuItemClassNames;
    },
    useMenuItemStyles_unstable: function() {
        return useMenuItemStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _index = require("../../selectable/index");
const menuItemClassNames = {
    root: 'fui-MenuItem',
    icon: 'fui-MenuItem__icon',
    checkmark: 'fui-MenuItem__checkmark',
    submenuIndicator: 'fui-MenuItem__submenuIndicator',
    content: 'fui-MenuItem__content',
    secondaryContent: 'fui-MenuItem__secondaryContent'
};
const useRootBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("rf4m57v", "rsbw0a0", {
    r: [
        ".rf4m57v{border-radius:var(--borderRadiusMedium);position:relative;color:var(--colorNeutralForeground2);background-color:var(--colorNeutralBackground1);padding-right:var(--spacingVerticalSNudge);padding-left:var(--spacingVerticalSNudge);padding-top:var(--spacingVerticalSNudge);padding-bottom:var(--spacingVerticalSNudge);box-sizing:border-box;max-width:290px;min-height:32px;flex-shrink:0;display:flex;align-items:start;font-size:var(--fontSizeBase300);cursor:pointer;gap:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}",
        ".rf4m57v:hover{background-color:var(--colorNeutralBackground1Hover);color:var(--colorNeutralForeground2Hover);}",
        ".rf4m57v:hover .fui-Icon-filled{display:inline;}",
        ".rf4m57v:hover .fui-Icon-regular{display:none;}",
        ".rf4m57v:hover .fui-MenuItem__icon{color:var(--colorNeutralForeground2BrandSelected);}",
        ".rf4m57v:hover:active{background-color:var(--colorNeutralBackground1Pressed);color:var(--colorNeutralForeground2Pressed);}",
        ".rf4m57v:focus{outline-style:none;}",
        ".rf4m57v:focus-visible{outline-style:none;}",
        ".rf4m57v[data-fui-focus-visible]{border-top-color:transparent;border-right-color:transparent;border-bottom-color:transparent;border-left-color:transparent;}",
        ".rf4m57v[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border-top-style:solid;border-right-style:solid;border-bottom-style:solid;border-left-style:solid;border-top-width:2px;border-right-width:2px;border-bottom-width:2px;border-left-width:2px;border-bottom-right-radius:var(--borderRadiusMedium);border-bottom-left-radius:var(--borderRadiusMedium);border-top-right-radius:var(--borderRadiusMedium);border-top-left-radius:var(--borderRadiusMedium);border-top-color:var(--colorStrokeFocus2);border-right-color:var(--colorStrokeFocus2);border-bottom-color:var(--colorStrokeFocus2);border-left-color:var(--colorStrokeFocus2);top:calc(2px * -1);right:calc(2px * -1);bottom:calc(2px * -1);left:calc(2px * -1);}",
        ".rsbw0a0{border-radius:var(--borderRadiusMedium);position:relative;color:var(--colorNeutralForeground2);background-color:var(--colorNeutralBackground1);padding-left:var(--spacingVerticalSNudge);padding-right:var(--spacingVerticalSNudge);padding-top:var(--spacingVerticalSNudge);padding-bottom:var(--spacingVerticalSNudge);box-sizing:border-box;max-width:290px;min-height:32px;flex-shrink:0;display:flex;align-items:start;font-size:var(--fontSizeBase300);cursor:pointer;gap:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}",
        ".rsbw0a0:hover{background-color:var(--colorNeutralBackground1Hover);color:var(--colorNeutralForeground2Hover);}",
        ".rsbw0a0:hover .fui-Icon-filled{display:inline;}",
        ".rsbw0a0:hover .fui-Icon-regular{display:none;}",
        ".rsbw0a0:hover .fui-MenuItem__icon{color:var(--colorNeutralForeground2BrandSelected);}",
        ".rsbw0a0:hover:active{background-color:var(--colorNeutralBackground1Pressed);color:var(--colorNeutralForeground2Pressed);}",
        ".rsbw0a0:focus{outline-style:none;}",
        ".rsbw0a0:focus-visible{outline-style:none;}",
        ".rsbw0a0[data-fui-focus-visible]{border-top-color:transparent;border-left-color:transparent;border-bottom-color:transparent;border-right-color:transparent;}",
        ".rsbw0a0[data-fui-focus-visible]::after{content:\"\";position:absolute;pointer-events:none;z-index:1;border-top-style:solid;border-left-style:solid;border-bottom-style:solid;border-right-style:solid;border-top-width:2px;border-left-width:2px;border-bottom-width:2px;border-right-width:2px;border-bottom-left-radius:var(--borderRadiusMedium);border-bottom-right-radius:var(--borderRadiusMedium);border-top-left-radius:var(--borderRadiusMedium);border-top-right-radius:var(--borderRadiusMedium);border-top-color:var(--colorStrokeFocus2);border-left-color:var(--colorStrokeFocus2);border-bottom-color:var(--colorStrokeFocus2);border-right-color:var(--colorStrokeFocus2);top:calc(2px * -1);left:calc(2px * -1);bottom:calc(2px * -1);right:calc(2px * -1);}"
    ],
    s: [
        "@media (forced-colors: active){.rf4m57v[data-fui-focus-visible]::after{border-top-color:Highlight;border-right-color:Highlight;border-bottom-color:Highlight;border-left-color:Highlight;}}",
        "@media (forced-colors: active){.rsbw0a0[data-fui-focus-visible]::after{border-top-color:Highlight;border-left-color:Highlight;border-bottom-color:Highlight;border-right-color:Highlight;}}"
    ]
});
const useContentBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r1ls86vo", "rpbc5dr", [
    ".r1ls86vo{padding-left:2px;padding-right:2px;background-color:transparent;flex-grow:1;}",
    ".rpbc5dr{padding-right:2px;padding-left:2px;background-color:transparent;flex-grow:1;}"
]);
const useSecondaryContentBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r12mwwux", "r1ewgu5j", [
    ".r12mwwux{padding-left:2px;padding-right:2px;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);color:var(--colorNeutralForeground3);}",
    ".r12mwwux:hover{color:var(--colorNeutralForeground3Hover);}",
    ".r12mwwux:focus{color:var(--colorNeutralForeground3Hover);}",
    ".r1ewgu5j{padding-right:2px;padding-left:2px;font-family:var(--fontFamilyBase);font-size:var(--fontSizeBase200);font-weight:var(--fontWeightRegular);line-height:var(--lineHeightBase300);color:var(--colorNeutralForeground3);}",
    ".r1ewgu5j:hover{color:var(--colorNeutralForeground3Hover);}",
    ".r1ewgu5j:focus{color:var(--colorNeutralForeground3Hover);}"
]);
const useIconBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r9c34qo", null, [
    ".r9c34qo{width:20px;height:20px;font-size:20px;line-height:0;align-items:center;display:inline-flex;justify-content:center;}"
]);
const useSubmenuIndicatorBaseStyles = /*#__PURE__*/ (0, _react.__resetStyles)("r9c34qo", null, [
    ".r9c34qo{width:20px;height:20px;font-size:20px;line-height:0;align-items:center;display:inline-flex;justify-content:center;}"
]);
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    checkmark: {
        B6of3ja: "fmnzpld"
    },
    splitItemMain: {
        Bh6795r: "fqerorx"
    },
    splitItemTrigger: {
        Btl43ni: [
            "f1ozlkrg",
            "f10ostut"
        ],
        Beyfa6y: [
            "f1deotkl",
            "f1krrbdw"
        ],
        uwmqm3: [
            "f1cnd47f",
            "fhxju0i"
        ],
        Ftih45: "f1wl9k8s",
        Ccq8qp: "f1yn80uh",
        Baz25je: "f68mna0",
        cmx5o7: "f1p5zmk"
    },
    disabled: {
        sj55zd: "f1s2aq7o",
        Bi91k9c: "fvgxktp",
        Jwef8y: "f1ijtazh",
        eoavqd: "fphbwmw",
        Bk3fhr4: "f19vpps7",
        Bmfj8id: "fv5swzo",
        Bg7n49j: "f1q1x1ba",
        B2d53fq: "fcvwxyo",
        iro3zm: "f1to34ca",
        t0hwav: "ft33916",
        Bbusuzp: "f1dcs8yz",
        ze5xyy: "f1kc2mi9",
        Bctn1xl: "fk56vqo",
        Bh6z0a4: "f1ikwg0d"
    }
}, {
    d: [
        ".fmnzpld{margin-top:2px;}",
        ".fqerorx{flex-grow:1;}",
        ".f1ozlkrg{border-top-left-radius:0;}",
        ".f10ostut{border-top-right-radius:0;}",
        ".f1deotkl{border-bottom-left-radius:0;}",
        ".f1krrbdw{border-bottom-right-radius:0;}",
        ".f1cnd47f{padding-left:0;}",
        ".fhxju0i{padding-right:0;}",
        ".f1wl9k8s::before{content:\"\";}",
        ".f1yn80uh::before{width:var(--strokeWidthThin);}",
        ".f68mna0::before{height:24px;}",
        ".f1p5zmk::before{background-color:var(--colorNeutralStroke1);}",
        ".f1s2aq7o{color:var(--colorNeutralForegroundDisabled);}"
    ],
    h: [
        ".fvgxktp:hover{color:var(--colorNeutralForegroundDisabled);}",
        ".f1ijtazh:hover{background-color:var(--colorNeutralBackground1);}",
        ".fphbwmw:hover{cursor:not-allowed;}",
        ".f19vpps7:hover .fui-Icon-filled{display:none;}",
        ".fv5swzo:hover .fui-Icon-regular{display:inline;}",
        ".f1q1x1ba:hover .fui-MenuItem__icon{color:var(--colorNeutralForegroundDisabled);}",
        ".fcvwxyo:hover:active{color:var(--colorNeutralForegroundDisabled);}",
        ".f1to34ca:hover:active{background-color:var(--colorNeutralBackground1);}"
    ],
    f: [
        ".ft33916:focus{color:var(--colorNeutralForegroundDisabled);}"
    ],
    m: [
        [
            "@media (forced-colors: active){.f1dcs8yz{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1kc2mi9:hover{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.fk56vqo:hover .fui-MenuItem__icon{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ],
        [
            "@media (forced-colors: active){.f1ikwg0d:focus{color:GrayText;}}",
            {
                m: "(forced-colors: active)"
            }
        ]
    ]
});
const useMenuItemStyles_unstable = (state)=>{
    const styles = useStyles();
    const rootBaseStyles = useRootBaseStyles();
    const contentBaseStyles = useContentBaseStyles();
    const secondaryContentBaseStyles = useSecondaryContentBaseStyles();
    const iconBaseStyles = useIconBaseStyles();
    const submenuIndicatorBaseStyles = useSubmenuIndicatorBaseStyles();
    state.root.className = (0, _react.mergeClasses)(menuItemClassNames.root, rootBaseStyles, state.disabled && styles.disabled, state.root.className);
    if (state.content) {
        state.content.className = (0, _react.mergeClasses)(menuItemClassNames.content, contentBaseStyles, state.content.className);
    }
    if (state.checkmark) {
        state.checkmark.className = (0, _react.mergeClasses)(menuItemClassNames.checkmark, styles.checkmark, state.checkmark.className);
    }
    if (state.secondaryContent) {
        state.secondaryContent.className = (0, _react.mergeClasses)(menuItemClassNames.secondaryContent, !state.disabled && secondaryContentBaseStyles, state.secondaryContent.className);
    }
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(menuItemClassNames.icon, iconBaseStyles, state.icon.className);
    }
    if (state.submenuIndicator) {
        state.submenuIndicator.className = (0, _react.mergeClasses)(menuItemClassNames.submenuIndicator, submenuIndicatorBaseStyles, state.submenuIndicator.className);
    }
    (0, _index.useCheckmarkStyles_unstable)(state);
    return state;
}; //# sourceMappingURL=useMenuItemStyles.styles.js.map
